exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item[data-v-90870df8]{cursor:pointer}", ""]);

// exports
